import { makeStyles, Text } from '@rneui/themed'
import { View } from 'react-native'

interface LeftArrowBannerProps {
  bannerText: string
}

export default function LeftArrowBanner({ bannerText }: LeftArrowBannerProps) {
  const styles = useStyles()
  return (
    <View style={styles.bannerContainer}>
      <View style={styles.triangle} />
      <View style={styles.rectangle}>
        <Text style={styles.bannerText}>{bannerText}</Text>
      </View>
    </View>
  )
}

const useStyles = makeStyles(theme => ({
  triangle: {
    width: 0,
    height: 0,
    borderStyle: 'solid',
    margin: 0,
    borderRightWidth: 25,
    borderBottomWidth: 25,
    borderTopWidth: 25,
    borderTopColor: 'transparent',
    borderRightColor: '#FFE2B3',
    borderBottomColor: 'transparent',
  },
  rectangle: {
    flex: 1,
    padding: 10,
    margin: 0,
    backgroundColor: '#FFE2B3',
    justifyContent: 'center',
    alignItems: 'center',
    height: 50,
    borderColor: 'black',
  },
  bannerContainer: {
    flex: 1,
    flexDirection: 'row',
    marginHorizontal: 10,
    paddingHorizontal: 10,
    alignItems: 'center',
  },
  bannerText: { color: theme.colors.grey3 },
}))
